var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Title'),_c('div',{staticClass:"inj-page__wrapper"},[(!_vm.mobileNavOpen)?_c('div',{staticClass:"inj-page__content"},[_c('router-view')],1):_vm._e(),_c('Nav')],1),_c('SaveChangesModal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }